export enum Bot {
  TELEGRAM = 'telegram',
  WHATSAPP = 'whatsapp',
}
